module.exports = __webpack_public_path__ + "img/ann_n.eed71e40.png";